import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=e9599606&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderInfo.vue?vue&type=style&index=0&id=e9599606&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e9599606",
  "6541554c"
  
)

/* custom blocks */
import block0 from "./OrderInfo.vue?vue&type=custom&index=0&blockType=sylee&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports